ixModuleRouting("impactx.pushmessage", {
    "/pushmessagelist": {
        template: '<ixa-push-message-list></ixa-push-message-list>',
        process: 'PushMessageAdmin',
        workspace: 'admin'
    },
    "/pushmessage/:id": {
        template: '<ixa-push-message-dialog></ixa-push-message-dialog>',
        process: 'PushMessageAdmin',
        workspace: 'admin'
    },

});
